import { Box, Container, Stack } from '@mui/material';
import { Navigate } from 'react-router-dom';

import { SpotterDetailsHeader } from '@/components/spotter/SpotterDetailsHeader';
import { HistoricalDataTabContainer } from '@/components/spotter/historicalDataTab/ObservationDataTabContainer';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

export const GridSpotterDetails = () => {
    const gridSpottersFlag = useFeatureFlag('mapSpottersGrid');

    if (!gridSpottersFlag) {
        return <Navigate to="/" />;
    }

    return (
        <Container maxWidth={false}>
            <Box sx={{ width: 1 }}>
                <Stack
                    direction="row"
                    sx={{
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderBottom: 1,
                        borderColor: 'divider',
                    }}
                >
                    <SpotterDetailsHeader />
                </Stack>
                <Box sx={{ py: 3, px: 1 }}>
                    <HistoricalDataTabContainer noSensorAlerts noCsvDownload />
                </Box>
            </Box>
        </Container>
    );
};
